/**
 * @file MakeLogo.tsx
 * @brief Make's own logo in place of the word "Make" (M1), theme-aware the
 *        same way as ZapierWordmark: both files rendered, `dark:` swaps them.
 *
 * @details
 * The files are Make's, as DES saved them from make.com's brand assets
 * (29-10-2026), shown UNMODIFIED: no recolour, crop or redraw. Height only;
 * the width follows. Not on the consent screen, which stays VERBLIZR only.
 *
 * @dependencies
 * - WEBPANEL/public/brand/partners/make-logo-dark.svg   (light theme)
 * - WEBPANEL/public/brand/partners/make-logo-white.svg  (dark theme)
 *
 * @author DES (prepared with Claude)
 * @date 29-10-2026
 */

import { cn } from "@/shared/theme/cn";

export function MakeLogo({ height = 22, className }: { height?: number; className?: string }) {
  return (
    <span className={cn("inline-flex shrink-0 items-center", className)} style={{ height }}>
      <img
        src="/brand/partners/make-logo-dark.svg"
        alt="Make"
        height={height}
        draggable={false}
        className="block h-full w-auto select-none dark:hidden"
      />
      <img
        src="/brand/partners/make-logo-white.svg"
        alt="Make"
        height={height}
        draggable={false}
        className="hidden h-full w-auto select-none dark:block"
      />
    </span>
  );
}
